<template>
  <div class="p-20 bg-white">
    <div>
      <Input v-model="searchParams.fuzzy" placeholder="请输入订单编号 / 企业名称 / 承刻单位名称" style="width: 300px"></Input>
      <Button class="m-l-10" type="success" ghost :loading="searching" @click="search">查询</Button>
    </div>
    <div class="p-t-15">
      <Table border :columns="columns" :data="dataPages.content"></Table>
      <div class="text-r p-15">
        <Page :total="dataPages.totalElements" :current="dataPages.number+1" show-elevator show-total
              :page-size="20" size="small" @on-change="search"></Page>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import pages from '@tubo/tubo-base/mixins/mixinPages'
  import {api} from '@/libs'

  export default {
    mixins: [pages],
    data() {
      return {
        param: {},
        columns: [

          {
            title: '申请单位名称',
            key: 'name',
            width: 200
          },
          {
            title: '承刻特行企业',
            width: 200,
            render: (h, w) => h('div', w.row.company ? w.row.company.name : '--')
          },
          {
            title: '印章数量',
            render: (h, w) => h('div', w.row.seals.length)
          },
          {
            title: '总价',
            render: (h, w) => h('div', Vue.filter('currency')(w.row.totalPrice))
          },
          {
            title: '订单状态',
            render: (h, w) => h('span', {
              directives: [{
                name: 'dict',
                value: w.row.orderState,
                arg: 'EntityGzwOrder_orderState'
              }]
            })
          },
          {
            title: '订单类型',
            render: (h, w) => h('span', {
              directives: [{
                name: 'dict',
                value: w.row.orderType,
                arg: 'EntityGzwOrder_orderType'
              }]
            })
          },
          {
            title: '操作',
            render: (h, w) => h('div', [h('a', {
              on: {
                click: () => {
                  this.$router.push({path: '/custom/order/show', query: {id: w.row.id}})
                }
              }
            }, '查看')])
          }
        ]
      }
    },
    computed: {
    },
    methods: {
    },
    created() {
      this.searchParams.fuzzyParams = ['code', 'name', 'company.name']
      this.searchApi = api.gzwCusOrder.orderHistory
    }
  }
</script>

<style scoped>

</style>
